import { render, staticRenderFns } from "./SentimentUpLimit.vue?vue&type=template&id=24841f7f&scoped=true"
import script from "./SentimentUpLimit.vue?vue&type=script&lang=js"
export * from "./SentimentUpLimit.vue?vue&type=script&lang=js"
import style0 from "./SentimentUpLimit.vue?vue&type=style&index=0&id=24841f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24841f7f",
  null
  
)

export default component.exports